import { forwardRef, type ReactNode } from "react";

const hoverStyles = {
  display: "flex",
  width: "42px",
  height: "42px",
  padding: "var(--spacing-scale-small-200, 2px)",
  justifyContent: "center",
  alignItems: "center",
  aspectRatio: "1/1",
  borderRadius: "var(--border-radius-rounded-lg, 6px)",
  transition: "background-color 0.15s ease-in-out",
} as const;

export const SidebarIconWrapper = forwardRef<
  HTMLDivElement,
  { children: ReactNode; className?: string; style?: React.CSSProperties } & React.HTMLAttributes<HTMLDivElement>
>(({ children, className, style, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={`sidebar-icon-wrapper ${className || ""}`}
      style={{ ...hoverStyles, ...style }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "var(--fixed-navbar-hover, #262626)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "transparent";
      }}
      {...props}
    >
      {children}
    </div>
  );
});

SidebarIconWrapper.displayName = "SidebarIconWrapper";
